import $ from "jquery"
import "slick-carousel-latest"

// global slick carousel
$('.js-slider-default').each(function () {
    var carousel = $(this);
    carousel.slick({
      infinite: carousel.data('infinite'),
      slidesToShow: carousel.data('items'),
      slidesToScroll: carousel.data('scroll'),
      arrows: carousel.data('arrows'),
      dots: carousel.data('dots'),
      autoplay: carousel.data('autoplay'),
      autoplaySpeed: carousel.data('speed'),
      speed: carousel.data('speedfade'),
      cssEase: carousel.data('ease'),
      fade: carousel.data('fade'),
      variableWidth: carousel.data('adaptive'),
      swipe: carousel.data('swipe'),
      pauseOnHover: carousel.data('pausefocus'),
      pauseOnFocus: carousel.data('pausehover'),
      adaptiveHeight: carousel.data('height'),
      prevArrow: $(carousel.data('prevarrow')),
      nextArrow: $(carousel.data('nextarrow')),
      responsive: [
            {
                breakpoint: 1400,
                settings: {
                variableWidth: carousel.data('adaptive-xl'),
                slidesToShow: carousel.data('items-xl'),
                slidesToScroll: carousel.data('scroll-xl')
                }
            },
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: carousel.data('items-lg'),
                slidesToScroll: carousel.data('scroll-lg')
                }
            },
          {
              breakpoint: 768,
              settings: {
                slidesToShow: carousel.data('items-ipad'),
                slidesToScroll: carousel.data('scroll-ipad')
              }
          },
          {
              breakpoint: 500,
              settings: {
                slidesToShow: carousel.data('items-mobi'),
                slidesToScroll: carousel.data('scroll-mobi')
              }
          }
      ]
    })
});